// Import Vuex
import store from '@/store';

// Directive to insert the translated text for a label in an element
export default {
  inserted: function(el, binding, vnode) {
    function setText() {
      const label = store.getters['translations/getLabel'](binding.value);
      if (label && label != el.innerText) el.innerText = label;
    }
    store.subscribe((mutation, state) => {
      if (mutation.type === 'translations/setLabels') setText();
    });
    setText();
  },
};
